import Utils from '~/scripts/services/utils';

export default class MailViewerAttachmentController {
	/* @ngInject */
	constructor() {
		/**
		 * @type {any}
		 */
		this.attachment = undefined;
	}

	download() {
		return Utils.download(
			this.attachment.data,
			this.attachment.mimetype,
			this.attachment.name,
		);
	}
}
